import React, { forwardRef, SVGAttributes } from "react";

export interface IconProps extends SVGAttributes<SVGElement> {
    /**
     * The stroke color of the icon
     * @default `currentColor`
     */
    color?: string;
    /**
     * The spot color of the icon
     */
    spotColor?: string;
    /**
     * The value of height and width for a square icon. For a rectangle icon, please use width/height prop instead.
     * @default `24`
     */
    size?: string | number;
}

const DEFAULT_SIZE = 24;

export const SVG = forwardRef<SVGSVGElement, IconProps>(
    ({ width, height, size = DEFAULT_SIZE, children, ...props }, ref) => {
        return (
            <svg width={width || size} height={height || size} ref={ref} {...props}>
                {children}
            </svg>
        );
    },
);

SVG.displayName = "Icon";
